function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3861 -1338) translate(3060 164) translate(205 144) translate(0 970) translate(16 16) translate(0 32) translate(568) translate(12 12)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#00AD50",
  rx: 20
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#CEFFB7",
  d: "M17.016 8.65l1.686-4.215c.083-.207.057-.44-.067-.624-.125-.184-.332-.295-.555-.295H9.598c-.37 0-.67.3-.67.67v6.027H7.367c-.37 0-.67.3-.67.67v2.232c0 .37.3.67.67.67H18.08c.223 0 .43-.11.555-.295.124-.184.15-.418.067-.624L17.016 8.65z",
  transform: "translate(10.476 8.571)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1E680",
  d: "M7.366 13.784c-.086 0-.173-.016-.256-.05-.25-.104-.414-.348-.414-.62v-2.231c0-.37.3-.67.67-.67h2.232c.271 0 .515.163.619.413.104.25.084 1.05-.107 1.242l-2.27 1.72c-.129.128-.3.196-.474.196z",
  transform: "translate(10.476 8.571)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.598 1.83H.67c-.37 0-.67.3-.67.67v8.929c0 .37.3.67.67.67h8.928c.37 0 .67-.3.67-.67V2.5c0-.37-.3-.67-.67-.67z",
  transform: "translate(10.476 8.571)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BCEDA5",
  d: "M.67 22.857c-.37 0-.67-.3-.67-.67V.67C0 .3.3 0 .67 0c.37 0 .67.3.67.67v21.518c0 .37-.3.67-.67.67z",
  transform: "translate(10.476 8.571)"
})))))))))));

var SvgIconServActivities = function SvgIconServActivities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconServActivities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-serv-activities.1f27fa7c.svg";
export { ForwardRef as ReactComponent };